export enum Perspective {
    FRONT = 'v',
    BACK = 'h'
}